import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the PagoPremioView.
 * @extends JetView
 */
export default class PagoPremioView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var object = {}; // Object to hold filter data

        // Event listener for 'pagoPremio:filter' event
        this.on(this.app, 'pagoPremio:filter', (filterData) => {
            object = filterData; // Update object with filter data
        });

        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Identification',
                    label: _('Identificación Usuario'), // User identification label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'PlayerName',
                    label: _('Nombre Usuario'), // User name label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'State',
                    label: _('Estado Premio'), // Prize state label
                    labelPosition: 'top',
                    options: [
                        { id: 'R', value: _('Comprado') }, // Option for 'Purchased'
                        { id: 'D', value: _('Entregado') }, // Option for 'Delivered'
                    ],
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Description',
                    label: _('Descripción Premio'), // Prize description label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
            ],
        };

        const upper_section = {
            cols: [
                { id: 'grav', gravity: 1 }, // Gravity for layout
                left, // Left section with form fields
                { id: 'grav1', gravity: 1 }, // Gravity for layout
            ],
        };

        const buttons = {
            margin: 10,
            cols: [
                { id: 'grav2', gravity: 1 }, // Gravity for layout
                {
                    view: 'button',
                    value: _('Pagar Premio'), // Button label for 'Pay Prize'
                    type: 'form',
                    id: 'ButtonPagarPremio', // Button ID
                    click: () => {
                        webix
                            .ui({
                                view: 'window',
                                head: _('Desea entregar premios?'), // Window title
                                modal: true, // Modal window
                                position: 'center',
                                body: {
                                    view: 'form',
                                    id: 'windowTransfersForm', // Form ID
                                    elements: [
                                        {
                                            view: 'text',
                                            label: _('Observación'), // Observation label
                                            labelPosition: 'top',
                                            name: 'Observation', // Observation field name
                                            required: true, // Field is required
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button',
                                                    value: _('Cancelar'), // Cancel button label
                                                    click: function (elementId, event) {
                                                        this.getTopParentView().hide(); // Hide window on cancel
                                                    },
                                                },
                                                {
                                                    view: 'button',
                                                    value: _('Aceptar'), // Accept button label
                                                    click: function (elementId, event) {
                                                        var values = $$('windowTransfersForm').getValues(); // Get form values
                                                        var vthis = this; // Reference to current context
                                                        if (
                                                            $$('windowTransfersForm').validate() // Validate form
                                                        ) {
                                                            let params = {
                                                                Ids: [
                                                                    object.NoTicket, // Ticket ID
                                                                ],
                                                                State: 'D', // Set state to 'Delivered'
                                                                Observation: values.Observation, // Observation value
                                                            };
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'Report/ChangeStateGiftAll', // API endpoint
                                                                    params, // Request parameters
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message(
                                                                                'Error! ', // Error message
                                                                            );
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var resp = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            if (
                                                                                !resp.HasError // Check for errors
                                                                            ) {
                                                                                webix.message(
                                                                                    _(
                                                                                        'Premios pagados satisfactoriamente', // Success message
                                                                                    ),
                                                                                );
                                                                                vthis.getTopParentView().hide(); // Hide window on success
                                                                            } else {
                                                                                webix.alert({
                                                                                    type: 'alert-error',
                                                                                    title: 'Error', // Alert title
                                                                                    text: _(
                                                                                        'Error! ', // Alert message
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                        } else {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error title
                                                                ),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Completa los campos...', // Error message
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate on change
                                            },
                                        },
                                    },
                                },
                                move: true, // Allow window to be moved
                            })
                            .show(); // Show the window
                    },
                },
                { id: 'grav3', gravity: 1 }, // Gravity for layout
            ],
        };

        return {
            view: 'form',
            id: 'formPagoPremio', // Form ID
            rows: [upper_section, buttons], // Form layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formPagoPremio').hide(); // Hide the form initially
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements for small screens
                $$('grav1').hide();
                $$('grav3').hide();
            }
        });
        // Event listener for 'pagoPremio:data' event
        this.on(this.app, 'pagoPremio:data', (premio) => {
            form.setValues(premio); // Set form values with prize data
        });
    }
}

// FILE DOCUMENTED
